<template>
  <div>
    <v-card
      class="mx-auto align-items-center border-shadow-card" 
      max-width="400"
      :loading="loading"
    >
      <v-toolbar>

        <elements-form-navigate-back @goBack="$emit('goBack')" v-if=showCommands />
        <v-toolbar-title class="text-h5">
          <strong>{{ coverage }}</strong> <em>coverage</em>
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ma-0"/>
      <v-card-text>
        <div v-if="!selectedPremiumValues.dollar || loading" class="text-center ma-5">
          <v-progress-circular
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <div v-else class="d-flex align-baseline">
          <div class="text-h2"> $ </div>
          <div class="text-h1 font-weight-bold"> {{ selectedPremiumValues.dollar }} </div>
          <div class="d-flex align-self-start s-40 text-disabled"> .{{ selectedPremiumValues.cents }} </div>
          <div class="text-disabled ml-3"> {{ selectedPremiumValues.frequency }} </div>
        </div>
      </v-card-text>
      <template v-if="showFrequencySelector || showCommands">
        <v-divider class="ma-0" />
        <v-card-actions class="d-flex space-between">
          <v-select
            v-if="showFrequencySelector"
            variant="outlined"
            bg-color="white"
            label="Payment Frequency"
            v-model="selectedPaymentFrequency"
            :items="premiums"
            item-title="PaymentFrequency"
            item-value="PaymentFrequency"
            hide-details="auto"
            density="comfortable"
            return-object
          >
          </v-select>
          <v-spacer></v-spacer>
          <v-btn
            class="color--white"
            v-if="showCommands"
            variant="flat"
            size="large"
            @click="$emit('submitForm')"
          >
            Get Covered Now
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
    <!-- <ElementsAgentCard></ElementsAgentCard> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "ComponentsElementsQuoteCard",

  props: {
    showCommands: {
      type: Boolean,
      default: () => false,
    },
    showFrequencySelector: {
      type: Boolean,
      default: () => false,
    },
    selectedPaymentFrequency: {
      type: String
    },
    loading: {
      type: Boolean,
      default: () => false,
    }
  },
  setup(props: any) {
    const { selectedPaymentFrequency } = props
    const currentQuoteStore = useCurrentQuoteStore()
    const premiums = ref(currentQuoteStore.currentQuote.premiums)
    const selectedPremium = ref<Premium | undefined>()
    if(selectedPaymentFrequency) {
      useCurrentQuoteStore().setSelecteedFrequency(selectedPaymentFrequency)
    }
    selectedPremium.value = (_get(currentQuoteStore?.currentQuote, "premiums", []).find((item: Premium) => item.PaymentFrequency === useCurrentQuoteStore().selectedFrequency) || undefined)
    const coverage = ref<string>(currentQuoteStore.currentQuote?.coverage || "Complete")
    const selectedPremiumValues = computed(() => {
      const frequency = _get(selectedPremium.value, "PaymentFrequency", "Monthly")
      const amount = _get(selectedPremium.value, "PremiumAmount", 0).toFixed(2)
      const dollar = amount.toString().split(".")[0]
      const cents = amount.toString().split(".")[1] || "00"
      return {amount, frequency, dollar, cents}
    })
    
    currentQuoteStore.$subscribe((mutation: any, state: any) => {
      const updatedQuoteStore = state.currentQuote
      coverage.value = _get(updatedQuoteStore, "coverage", "Complete")
      selectedPremium.value = _get(updatedQuoteStore, "premiums", []).find((item: any) => item.PaymentFrequency === useCurrentQuoteStore().selectedFrequency)
    })

    return {
      selectedPaymentFrequency,
      premiums,
      selectedPremium,
      selectedPremiumValues,
      coverage
    };
  }
});
</script>
